import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { LoadingButton } from '@mui/lab';
import { Button, TextField } from '@mui/material';
import { postManualPayout } from 'src/api/oApi';
import { generalStore } from 'src/stores/GeneralStore';

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function ManualPayoutDialog({
  open,
  setOpen,
  userData,
  forceReload,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  userData: {
    userId: string;
  };
  forceReload?: () => void;
}) {
  const [amount, setAmount] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const submit = async () => {
    setIsLoading(true);
    try {
      await postManualPayout({ userId: userData.userId, amount: Number(amount) });
      generalStore.setMessage('Manual payout submitted successfully');
      setAmount('');
      setOpen(false);
      if (forceReload) forceReload();
    } catch (error: any) {
      generalStore.setError(
        error?.response?.data?.error?.message || error?.response?.data?.error || error?.message || 'Error on Operation',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>Manual Payout</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 1 }}>Enter the amount that should be paid out manually to this user.</DialogContentText>
        <TextField
          autoFocus
          fullWidth
          sx={{ mt: 1 }}
          label="Amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton loading={isLoading} disabled={!amount || Number(amount) <= 0} onClick={submit} color="primary" variant="contained">
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
